import { useTranslation } from 'react-i18next';
import Layout from '@/components/feature/Layout';
import Reveal from '@/components/feature/Reveal';

export default function Privacy() {
  const { t } = useTranslation();

  const sections = [
    { title: t('privacy.introTitle'), content: t('privacy.introContent') },
    { title: t('privacy.infoTitle'), content: t('privacy.infoContent') },
    { title: t('privacy.useTitle'), content: t('privacy.useContent') },
    { title: t('privacy.sharingTitle'), content: t('privacy.sharingContent') },
    { title: t('privacy.securityTitle'), content: t('privacy.securityContent') },
    { title: t('privacy.cookiesTitle'), content: t('privacy.cookiesContent') },
    { title: t('privacy.rightsTitle'), content: t('privacy.rightsContent') },
    { title: t('privacy.changesTitle'), content: t('privacy.changesContent') },
    { title: t('privacy.contactTitle'), content: t('privacy.contactContent') },
  ];

  return (
    <Layout showTopBar>
      {/* Hero */}
      <section className="relative w-full h-[360px] md:h-[440px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20elegant%20cafe%20interior%20with%20soft%20golden%20ambient%20lighting%2C%20wooden%20tables%20and%20artisan%20coffee%20cups%2C%20minimal%20premium%20hospitality%20atmosphere%2C%20editorial%20interior%20photography%2C%20rich%20warm%20tones%2C%20inviting%20cozy%20mood&width=1600&height=700&seq=privacy-hero-01&orientation=landscape"
          alt="BIOLA Cafe Privacy"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/30 to-foreground-950/50" />
        <div className="absolute inset-0 flex items-center justify-center px-4">
          <div className="text-center max-w-2xl">
            <span className="inline-block w-12 h-12 flex items-center justify-center bg-primary-500 text-background-50 rounded-xl mx-auto mb-4 animate-hero-content">
              <i className="ri-shield-user-line text-xl" />
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-3 animate-hero-content-delay">
              {t('privacy.pageTitle')}
            </h1>
            <p className="text-background-100 text-sm md:text-base animate-hero-content-delay-2">
              {t('privacy.pageSubtitle')}
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-50">
        <div className="max-w-5xl mx-auto">
          <Reveal>
            <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70">
              <p className="text-foreground-500 text-sm mb-8">
                <strong className="text-foreground-700">{t('privacy.effective')}</strong> {t('privacy.effectiveDate')}
              </p>

              <div className="space-y-8">
                {sections.map((section, index) => (
                  <Reveal key={section.title} delay={index * 40}>
                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3 flex items-center gap-3">
                        <span className="w-7 h-7 flex items-center justify-center bg-primary-100 text-primary-600 rounded-md text-xs font-bold">
                          {index + 1}
                        </span>
                        {section.title}
                      </h2>
                      <p className="text-foreground-600 text-sm md:text-base leading-relaxed pl-10">
                        {section.content}
                      </p>
                    </div>
                  </Reveal>
                ))}
              </div>

              <div className="mt-10 pt-6 border-t border-background-200/70">
                <p className="text-foreground-500 text-sm text-center">
                  {t('privacy.footer', { year: new Date().getFullYear() })}
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </Layout>
  );
}